import * as z from 'zod';

import { TeamId, UserId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils';
import { DashboardTaskType } from './Task';
import { TaskStatus } from './TaskStatus';

export const TaskStatusFilter = z.object({
  type: z.literal('enum'),
  key: z.literal('status'),
  filter: z.object({
    values: z.array(TaskStatus),
  }),
});
export type TaskStatusFilter = z.infer<typeof TaskStatusFilter>;

export const TaskDueStatus = z.enum(['late', 'onTime', 'none']);
export type TaskDueStatus = z.infer<typeof TaskDueStatus>;
export const TaskDueStatusFilter = z.object({
  type: z.literal('enum'),
  key: z.literal('dueStatus'),
  filter: z.object({
    values: z.array(TaskDueStatus),
  }),
});
export type TaskDueStatusFilter = z.infer<typeof TaskDueStatusFilter>;

// Validate prefixed assignee formats: "user:uuid" or "team:uuid"
const PrefixedUserId = z
  .string()
  .refine((val) => val.startsWith('user:') && zodBrandedUuid<UserId>().safeParse(val.substring(5)).success, {
    message: 'Must be format "user:uuid"',
  });

const PrefixedTeamId = z
  .string()
  .refine((val) => val.startsWith('team:') && zodBrandedUuid<TeamId>().safeParse(val.substring(5)).success, {
    message: 'Must be format "team:uuid"',
  });

// TODO followup: remove zodBrandedUuid<UserId>() after the new format has been deployed
export const TaskAssignee = z.union([z.literal('none'), zodBrandedUuid<UserId>(), PrefixedUserId, PrefixedTeamId]);
export type TaskAssignee = z.infer<typeof TaskAssignee>;
export const TaskAssigneeFilter = z.object({
  type: z.literal('enum'),
  key: z.literal('assignee'),
  filter: z.object({
    values: z.array(TaskAssignee),
  }),
});
export type TaskAssigneeFilter = z.infer<typeof TaskAssigneeFilter>;

export const TaskTypeFilter = z.object({
  type: z.literal('enum'),
  key: z.literal('type'),
  filter: z.object({
    values: z.array(DashboardTaskType),
  }),
});
export type TaskTypeFilter = z.infer<typeof TaskTypeFilter>;

export const TaskFilter = z.discriminatedUnion('key', [
  TaskStatusFilter,
  TaskTypeFilter,
  TaskDueStatusFilter,
  TaskAssigneeFilter,
]);
export type TaskFilter = z.infer<typeof TaskFilter>;
